import './password_reset.css';
import { Header } from '../../components/header/Header';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useLang } from '../../context/LangContext';
import { useEffect, useState } from 'react';
import { BarLoader } from '../../components/BarLoader/BarLoader';
import { useServer } from '../../context/serverContext';
import { endpoints } from '../../env';

export function PasswordReset() {
    //HOOKS
    const [searchParams, setSearchParams] = useSearchParams();
    const { lang } = useLang();
    const { postRequest } = useServer();
    const navigate = useNavigate();

    //STATES
    const [pwd, setPwd] = useState("");
    const [pwd2, setPwd2] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [loading, setLoading] = useState("");
    const [token, setToken] = useState("");

    //FUNCTIONS
    const changePassword = () => {
        if (loading) {
            return;
        }

        if (pwd !== pwd2) {
            setErrorMsg(lang === "en" ? "The passwords do not match" : "Las contraseñas no coinciden");
            return;
        }

        setLoading(false);
        setErrorMsg("");

        let data = {
            token: token,
            password: pwd,
        };

        postRequest(endpoints.passwordReset, data, (res) => {
            setLoading(false);

            if (res[0]) {
                res = res[1];
                if (res.success) {
                    navigate('/login', {replace: true});
                } else {
                    if (res.error === "token_invalid") {
                        setErrorMsg(lang === "en" ? "Recovery link expired, please request a new email to recover your password." : "Enlace de recuperacion expirado, por favor solicita un nuevo correo para recuperar tu contraseña");
                    }

                    if (res.error === "password_required") {
                        setErrorMsg(lang === "en" ? "All fields are required" : "Todos los campos son requeridos");
                    }
                }
            } else {
                setErrorMsg(lang === "en" ? "Server error, please try again in a bit": "Error del servidor, intenta de nuevo en un momento");
            }
        });
    }

    //EFFECTS
    useEffect(() => {
        setToken(searchParams.get("token"));
    }, [searchParams]);

    return (
        <>
            <Header />
            <div className='pwdreset_form_body'>
                <div className='form'>
                    <div className='input_container'>
                        <label>
                            { lang === "en" ? "Password" : "Contraseña" }
                        </label>
                        <input type='password' placeholder={ lang === "en" ? "Password" : "Contraseña" } value={pwd} onChange={(e) => setPwd(e.target.value)} />
                    </div>
                    <div className='input_container'>
                        <label>
                            { lang === "en" ? "Repeat the password" : "Repite la contraseña" }
                        </label>
                        <input type='password' placeholder={ lang === "en" ? "Repeat the password" : "Repite la contraseña" } value={pwd2} onChange={(e) => setPwd2(e.target.value)} />
                    </div>
                    {errorMsg !== "" && 
                        (
                            <div className='error_msg'>
                                {errorMsg}
                            </div>
                        )
                    }
                    <button onClick={changePassword}>
                        { lang === "en" ? "Change password" : "Cambiar contraseña"}
                    </button>
                    {loading && 
                        (
                            <div className='loader'>
                                <BarLoader />
                            </div>
                        )
                    }
                </div>
            </div>
        </>
    );
}